import { useEffect } from "react";
import { userManager } from "../auth/authService";

export default function OidcSilentCallback() {
    useEffect(() => {
        userManager.signinSilentCallback().catch((error) => {
            console.error("OIDC silent callback failed:", error);
        });
    }, []);

    return null;
}